
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 46 31","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".277","y":".375","width":"45.467","height":"30.109","rx":"5","fill":"#CE1312"}}),_c('path',{attrs:{"d":"M12.79 20.93l-2.406-7.841h-.062l.041.848c.023.373.044.772.062 1.196.018.424.027.807.027 1.148v4.649H8.56v-9.995h2.884l2.366 7.643h.04l2.51-7.643h2.884v9.995h-1.975V16.2c0-.315.004-.677.013-1.088.014-.41.03-.8.048-1.169l.041-.84h-.061L14.73 20.93H12.79zm12.168-9.995c1.29 0 2.23.278 2.823.835.593.551.889 1.312.889 2.283 0 .437-.066.856-.198 1.257a2.76 2.76 0 01-.65 1.06c-.296.31-.692.556-1.19.738-.496.178-1.109.267-1.838.267h-.91v3.555h-2.118v-9.995h3.192zm-.11 1.737h-.963v2.967h.697c.396 0 .74-.053 1.032-.158.292-.104.517-.268.677-.492.16-.223.24-.51.24-.861 0-.492-.137-.857-.41-1.094-.274-.241-.698-.362-1.272-.362zm12.223 6.186h-1.203v2.072h-2.064v-2.072h-4.266v-1.47l4.382-6.453h1.948v6.283h1.203v1.64zm-3.267-1.64v-1.695c0-.16.002-.35.006-.568l.028-.656c.009-.219.018-.413.027-.581l.028-.363h-.055c-.087.187-.178.37-.273.547a7.74 7.74 0 01-.335.547l-1.832 2.769h2.406z","fill":"#fff"}})])
          )
        }
      }
    